var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_vm._t("default"),_vm._t("main",function(){return [_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)]}),_c('pwa-install-dialog'),_c('pwa-snackbar'),_c('app-dialog-remove')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }